import React from 'react';
import { ChevronDown } from 'lucide-react';
import TarihGirisi from './TarihGirisi';
import { tarihFarki } from './tarihHesaplamalari';
import { farkMetni } from './asamalar';

const yasGruplari = [
  { id: 'yetiskin', label: '18 yaş ve üzeri' },
  { id: '15-18', label: '15–18 yaş arası' },
  { id: '12-15', label: '12–15 yaş arası' },
];

function SegmentDugmesi({ aktif, onClick, children }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`rounded px-2 py-0.5 text-[11px] font-medium transition-colors ${
        aktif ? 'bg-white text-indigo-600 shadow-sm' : 'text-slate-500 hover:text-slate-700'
      }`}
    >
      {children}
    </button>
  );
}

function YasGrubuSecimi({
  dogumTarihi,
  onDogumTarihiChange,
  sucTarihi,
  manuelYasGrubu,
  onManuelChange,
  secilenYasGrubu,
  onYasGrubuChange,
  otomatikYasGrubu,
  hata,
}) {
  // Suç tarihindeki yaş — tam yıl/ay/gün (tarih farkı sayfasıyla aynı biçim).
  const fark =
    dogumTarihi && sucTarihi && new Date(dogumTarihi) <= new Date(sucTarihi)
      ? tarihFarki(new Date(dogumTarihi), new Date(sucTarihi))
      : null;
  const grupLabel = yasGruplari.find((g) => g.id === otomatikYasGrubu)?.label;

  return (
    <div>
      <div className="mb-1.5 flex h-7 items-center justify-between gap-2">
        <label className="text-sm font-medium text-slate-700">Yaş grubu (66/2)</label>
        <div className="inline-flex rounded-md border border-slate-200 bg-slate-100 p-0.5">
          <SegmentDugmesi aktif={!manuelYasGrubu} onClick={() => onManuelChange(false)}>
            Doğum t.
          </SegmentDugmesi>
          <SegmentDugmesi aktif={manuelYasGrubu} onClick={() => onManuelChange(true)}>
            Elle
          </SegmentDugmesi>
        </div>
      </div>

      {!manuelYasGrubu ? (
        <>
          <TarihGirisi value={dogumTarihi} onChange={onDogumTarihiChange} />
          {hata ? (
            <p className="mt-1.5 text-xs font-medium text-rose-600 leading-snug">{hata}</p>
          ) : otomatikYasGrubu && fark ? (
            <p className="mt-1.5 text-xs text-slate-500 leading-snug">
              Suç tarihinde <span className="font-medium text-slate-700">{farkMetni(fark)}</span> — {grupLabel}
            </p>
          ) : (
            <p className="mt-1.5 text-xs text-slate-400 leading-snug">Otomatik yaş grubu için doğum tarihi girin.</p>
          )}
        </>
      ) : (
        <>
          <div className="relative">
            <select
              value={secilenYasGrubu}
              onChange={(e) => onYasGrubuChange(e.target.value)}
              className="w-full appearance-none rounded-lg border border-slate-300 bg-white px-3 py-2.5 pr-9 text-sm text-slate-900 shadow-sm transition-colors focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30"
            >
              {yasGruplari.map((grup) => (
                <option key={grup.id} value={grup.id}>
                  {grup.label}
                </option>
              ))}
            </select>
            <ChevronDown className="pointer-events-none absolute right-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
          </div>
          <p className="mt-1.5 text-xs text-slate-500 leading-snug">
            Seçilen yaş grubuna göre süre indirimi uygulanır.
          </p>
        </>
      )}
    </div>
  );
}

export default YasGrubuSecimi;
